
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"80","height":"80","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.334 40a36.561 36.561 0 0036.667 36.667A36.561 36.561 0 0076.667 40 36.561 36.561 0 0040.001 3.334 36.561 36.561 0 003.334 40zm6.667 0c0-16.666 13.333-30 30-30 16.666 0 30 13.334 30 30 0 16.667-13.334 30-30 30-16.667 0-30-13.333-30-30zm33.333 0V26.667c0-2-1.333-3.334-3.333-3.334s-3.334 1.334-3.334 3.334V40c0 2 1.334 3.334 3.334 3.334S43.334 42 43.334 40zm-.333 14.667c0 .333-.334.666-.667 1-.667.666-1.333 1-2.667 1-1 0-1.666-.334-2.333-1-.667-.667-1-1.334-1-2.334 0-.39.114-.666.21-.895.066-.162.123-.3.123-.438 0-.333.334-.666.667-1 1-1 2.333-1.333 3.667-.666.166 0 .25.083.333.166.083.084.167.167.333.167.334 0 .667.333.667.333.167.167.25.334.333.5.084.167.167.334.334.5.333.334.333 1 .333 1.334 0 .166-.083.416-.167.666-.083.25-.166.5-.166.667z","fill":"#EEAC55"}})])
          )
        }
      }
    